export default __webpack_public_path__ + "static/foterLogo-8592a7cc1fca1dfdc23aa16cefae580c.png";